import { useState, useEffect } from "react";

export function useDelayedUnmount(isVisible: boolean, delay: number) {
  const [shouldRender, setShouldRender] = useState(isVisible);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isVisible && !shouldRender) {
      setShouldRender(true);
    }

    if (!isVisible && shouldRender) {
      timeoutId = setTimeout(() => setShouldRender(false), delay);
    }

    return () => clearTimeout(timeoutId);
  }, [delay, isVisible, shouldRender]);

  return shouldRender;
}
